export async function apiClient(path, accessToken, options = {}) {
    let _options = {...options}
    _options.headers = {
        'Content-Type': 'application/json',
        'Authorization': `Token token="${accessToken}"`,
        ...options.headers
    }
    const response = await fetch(path, {
        ..._options
    })

    if (!response.ok) {
        const error = await response.json().catch(() => ({}))
        throw new Error(error.message || 'API request failed')
    }

    return response.json()
}